import type { GrowthPackDefinition } from '../../../domain/industry/types';
import { buildPack, PACK_CONTENT } from './packBuilder';

const growthPacks: GrowthPackDefinition[] = [
  {
    id: 'saas_growth_starter',
    industryId: 'saas_b2b',
    tier: 1,
    name: 'Core SaaS',
    description: 'DevOps and API products with vendor-risk mission.',
    unlocks: {
      productIds: ['saas_devops', 'saas_api'],
      missionIds: ['saas_mission_vendor'],
    },
  },
  {
    id: 'saas_growth_enterprise',
    industryId: 'saas_b2b',
    tier: 2,
    name: 'Enterprise Suite',
    description: 'ERP unlock after vendor diligence.',
    unlockConditions: { completedMissionIds: ['saas_mission_vendor'] },
    unlocks: {
      productIds: ['saas_erp', 'saas_legaltech', 'saas_proptech'],
      missionIds: ['saas_mission_controls'],
    },
  },
  {
    id: 'saas_growth_gov',
    industryId: 'saas_b2b',
    tier: 3,
    name: 'Gov & SecOps',
    description: 'FedRAMP and SecOps for regulated buyers.',
    unlockConditions: { completedMissionIds: ['saas_mission_controls'], minCompliance: 75 },
    unlocks: {
      productIds: ['saas_secops', 'saas_govcloud'],
      missionIds: ['saas_mission_pentest'],
    },
  },
];

export const saasB2bPack = buildPack({
  id: 'saas_b2b',
  ...PACK_CONTENT.saas_b2b,
  growthPacks,
  expansionPacks: [
    {
      id: 'saas_exp_verticals',
      industryId: 'saas_b2b',
      name: 'Vertical SaaS Bundle',
      version: '1.0.0',
      description: 'Healthcare and EdTech vertical modules for B2B platform.',
      requiresGrowthTierId: 'saas_growth_enterprise',
      adds: {
        frameworkIds: ['gdpr'],
      },
    },
  ],
});